var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0002 13.7994C24.0002 16.7994 21.6002 19.1994 18.6002 19.1994H12.6002C9.6002 19.1994 7.2002 16.7994 7.2002 13.7994C7.2002 10.7994 9.6002 8.39941 12.6002 8.39941H13.8002C14.1752 8.88691 14.4002 9.52441 14.4002 10.1994C14.4002 10.4244 14.3627 10.6119 14.3252 10.7994H12.6002C10.9502 10.7994 9.6002 12.1494 9.6002 13.7994C9.6002 15.4494 10.9502 16.7994 12.6002 16.7994H18.6002C20.2502 16.7994 21.6002 15.4494 21.6002 13.7994C21.6002 12.1494 20.2502 10.7994 18.6002 10.7994H16.7252C16.7627 10.6119 16.8002 10.3869 16.8002 10.1994C16.8002 9.56191 16.6877 8.96191 16.4627 8.39941H18.6002C21.6002 8.39941 24.0002 10.7994 24.0002 13.7994Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.1998C0 7.1998 2.4 4.7998 5.4 4.7998H11.4C14.4 4.7998 16.8 7.1998 16.8 10.1998C16.8 13.1998 14.4 15.5998 11.4 15.5998H10.2C9.825 15.1123 9.6 14.4748 9.6 13.7998C9.6 13.5748 9.6375 13.3873 9.675 13.1998H11.4C13.05 13.1998 14.4 11.8498 14.4 10.1998C14.4 8.5498 13.05 7.1998 11.4 7.1998H5.4C3.75 7.1998 2.4 8.5498 2.4 10.1998C2.4 11.8498 3.75 13.1998 5.4 13.1998H7.275C7.2375 13.3873 7.2 13.6123 7.2 13.7998C7.2 14.4373 7.3125 15.0373 7.5375 15.5998H5.4C2.4 15.5998 0 13.1998 0 10.1998Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHorizontal);
export default __webpack_public_path__ + "static/media/link-horizontal.7809debc37eb7498dc54de68d1468600.svg";
export { ForwardRef as ReactComponent };